export const OVERVIEW_TYPE = {
  parcel: 'parcel',
  payment: 'payment'
}
